export default __webpack_public_path__ + "static/media/diagram.bf6966ca.png";